import React, { useState, useEffect } from "react";
import { Menubar } from "primereact/menubar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useGlobalContext } from "../../context/GlobalContext";
import Cookies from "js-cookie";
import "../../assets/css/dashboard.css";
import "../../assets/css/primecustomdashboard.css";
import Header from "../../components/header/Header";
import tb_logo from "../../assets/images/tb_logo.png";
import Reports from "../reports/Reports";
import { PROJECT_PANEL, SELECTED_CLIENT_NAME } from "../../utils/constants";
import { getCategoryData } from "../../services/layout/layout";
import handleError from "../../utils/handleError";
import superAdminMenuItems from "../../assets/json/superAdminMenuItems.json";
import superAdminAllPathnames from "../../assets/json/superAdminAllPathnames.json";
import AdminHeader from "../../components/admin/adminHeader/AdminHeader";
import { toSentenceCase } from "../../utils/constants";
import { getClientSpecificCategory } from "../../services/admin/client/client";
import clientPathnames from "../../assets/json/clientPathnames.json";

const Layout = ({ renderReports }) => {
  const {
    setDevice,
    setDeviceCode,
    setCategory,
    setProductId,
    setMappedCategory,
    setProjectId,
    showSidebar,
    setShowSidebar,
    setIsDemoCategory,
    isDemoCategory,
    product_id,
    category: selectedCategory,
    setIsCustomRecruitCategory,
    setIsDualCategory,
  } = useGlobalContext();

  const { panel_projects, token, user, selectedClientName } = useSelector(
    (state) => state.auth,
  );
  const [categoryData, setCategoryData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [match, setMatch] = useState(null);
  const [id, setId] = useState(null);
  let lastSegment = location.pathname.split("/").pop();
  let lastSegmentParts = lastSegment.split("-");
  if (lastSegmentParts.length > 2) {
    // Remove the third part (index 2)
    lastSegmentParts.splice(2, 1);
  }
  lastSegment = lastSegmentParts.join("-");

  const getSubheaderByPathname = (pathname) => {
    const menuItem = superAdminAllPathnames.find(
      (item) => item.path === pathname,
    );
    return menuItem ? menuItem.label : null;
  };

  const getClientSubheaderByPathname = (pathname) => {
    const pathParts = pathname.split("/");
    const menuItem = clientPathnames.find((item) =>
      pathParts.length > 2
        ? item.path.includes(pathParts[2])
        : item.path.includes(pathParts[1]),
    );
    return menuItem ? menuItem.label : null;
  };

  const [subHeaderText, setSubHeaderText] = useState(
    getSubheaderByPathname(window.location.pathname),
  );
  const [clientSubHeaderText, setClientSubHeaderText] = useState(
    getClientSubheaderByPathname(window.location.pathname),
  );
  const [selectePanelProject, setSelectedPanelProject] = useState(
    PROJECT_PANEL.SMART_PANEL,
  );

  const cookieSelectedPath = Cookies.get("selectedPath");
  const cookieSelectedMenu = Cookies.get("selectedMenu");

  const initialSelectedPath =
    cookieSelectedPath || location.pathname || "/dashboard";
  const initialSelectedMenu =
    cookieSelectedMenu || location.pathname || "/dashboard";

  const [menuItemsData, setMenuItemsData] = useState([]);
  const [selectedPath, setSelectedPath] = useState(initialSelectedPath);
  const [selectedMenu, setSelectedMenu] = useState(initialSelectedMenu);
  // const [menuKey, setMenuKey] = useState(0);
  useEffect(() => {
    if (
      !location.pathname.includes("fromClient") &&
      location.pathname.includes("/admin-panel/categories/fromAdmin")
    ) {
      getCategoryPanelProjectData();
    } else if (user?.type === "admin_user" || user?.type === "client") {
      getCategoryPanelProjectData();
    }
  }, [selectePanelProject, id, location.pathname]);

  useEffect(() => {
    if (match) {
      setCategoryData([]);
      // set selectedClientName here
      dispatch({
        type: SELECTED_CLIENT_NAME,
        payload: null,
      });
      const reqBody = {
        client_id: parseInt(id),
        type: "client",
      };
      getClientSpecificCategory(token, reqBody)
        .then((response) => {
          // debugger;
          if (response.data.success === 1) {
            setProjectId(
              selectePanelProject === PROJECT_PANEL.SMART_PANEL
                ? parseInt(panel_projects.smart_panel)
                : parseInt(panel_projects.test_panel),
            );
            setCategoryData(response.data.client_category_data || []);
            // set selectedClientName here
            dispatch({
              type: SELECTED_CLIENT_NAME,
              payload: response.data.client_name || null,
            });
            // setMenuKey((prevKey) => prevKey + 1);
            setLoading(false);
            const firstCategory = response?.data?.client_category_data?.[0];
            if (
              firstCategory &&
              location.pathname.includes("admin-panel/categories/fromClient")
            ) {
              handleMenuItemClick(
                window.location.pathname,
                `/category/${firstCategory.id}`,
                firstCategory.device,
                firstCategory.device_code,
                firstCategory.category,
                firstCategory.tag_or_coaster_category_id,
                firstCategory.mapped_category,
                firstCategory?.demo_category,
              );
            }
          }
        })
        .catch((error) => {
          handleError(error, navigate, dispatch);
        });
    }
  }, [selectePanelProject, id]);

  const getCategoryPanelProjectData = () => {
    let reqBody = {
      id: parseInt(user.id),
      study_id:
        selectePanelProject === PROJECT_PANEL.SMART_PANEL
          ? parseInt(panel_projects.smart_panel)
          : parseInt(panel_projects.test_panel),
    };
    if (user?.type === "admin_user" || user?.type === "admin_user") {
      reqBody.client_id = user?.client_id;
    }
    getCategoryData(reqBody, token)
      .then((response) => {
        if (response?.data?.category_data) {
          setCategoryData(response.data.category_data);
          // set selectedClientName here
          dispatch({
            type: SELECTED_CLIENT_NAME,
            payload: null,
          });
          setProjectId(reqBody.study_id);
          setLoading(false);
          if (
            user?.type === "superadmin" &&
            location.pathname === "/admin-panel/categories/fromAdmin"
          ) {
            const firstCategory = response?.data?.category_data?.[0];
            if (firstCategory) {
              handleMenuItemClick(
                `/admin-panel/categories/fromAdmin`,
                `/category/${firstCategory.id}`,
                firstCategory.device,
                firstCategory.device_code,
                firstCategory.category,
                firstCategory.tag_or_coaster_category_id,
                firstCategory.mapped_category,
                firstCategory?.demo_category,
                firstCategory?.recruitment_category_id,
                firstCategory?.study_id,
              );
            }
          }
        } else {
          console.error("category data not found");
        }
      })
      .catch((error) => {
        handleError(error, navigate, dispatch);
      });
  };

  function InitializeMenuSelection() {
    if (categoryData.length > 0) {
      const newPath = `/category/${categoryData[0].id}`;
      const newSelectedMenu = `/category/${categoryData[0].id}`;
      Cookies.set("selectedMenuPath", newPath, { expires: 7 });
      Cookies.set("selectedMenu", newSelectedMenu, { expires: 7 });
      setSelectedPath(newPath);
      setSelectedMenu(newSelectedMenu);
      setDevice(categoryData[0].device);
      setDeviceCode(categoryData[0].device_code);
      setIsDualCategory(categoryData[0]?.is_dual ? true : false);
      setCategory(categoryData[0].category);
      setIsDemoCategory(
        categoryData[0]?.demo_category
          ? categoryData[0]?.demo_category === "1"
            ? true
            : false
          : false,
      );
      setIsCustomRecruitCategory(
        categoryData[0]?.custom_recruit ? true : false,
      );
      setProductId(categoryData[0].tag_or_coaster_category_id);
      setMappedCategory(categoryData[0].mapped_category);
    }
  }

  useEffect(() => {
    if (user?.type === "superadmin") return;
    InitializeMenuSelection();
  }, [
    categoryData,
    setDevice,
    setDeviceCode,
    setCategory,
    setIsDemoCategory,
    setProductId,
    setMappedCategory,
  ]);

  // useEffect(() => {
  //   const observer = new MutationObserver(() => {
  //     // Delay to ensure DOM is fully updated
  //     requestAnimationFrame(() => {
  //       const highlightedItem = document.querySelector(
  //         ".p-menubar-root-list li.p-highlighter",
  //       );

  //       if (highlightedItem) {
  //         const rect = highlightedItem.getBoundingClientRect();
  //         const isInViewport =
  //           rect.top >= 0 &&
  //           rect.bottom <=
  //             (window.innerHeight || document.documentElement.clientHeight);

  //         if (!isInViewport) {
  //           highlightedItem.scrollIntoView({
  //             behavior: "smooth",
  //             block: "nearest",
  //           });
  //         }
  //       }
  //     });
  //   });

  //   const menuContainer = document.querySelector(".p-menubar-root-list");

  //   if (menuContainer) {
  //     observer.observe(menuContainer, {
  //       childList: true,
  //       subtree: true,
  //       attributes: true,
  //       attributeFilter: ["class"],
  //     });
  //   }

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, []);

  const normalizePath = (p) => (p.endsWith("/") ? p.slice(0, -1) : p);

  const handleMenuItemClick = (
    newPath,
    newMenu,
    device,
    deviceCode,
    category,
    product_id,
    mapped_category,
    demo_category,
    recruit_category,
    study_id,
    dual_category,
  ) => {
    setProjectId(
      recruit_category
        ? study_id
        : selectePanelProject === PROJECT_PANEL.SMART_PANEL
          ? parseInt(panel_projects.smart_panel)
          : parseInt(panel_projects.test_panel),
    );
    // Special handling for surveys
    if (newMenu === "/dashboard/survey") {
      navigate("/dashboard/survey");
      return;
    } else if (newMenu === "/dashboard/users") {
      navigate("/dashboard/users");
      return;
    } else if (newMenu === "/dashboard/other-activities") {
      navigate("/dashboard/other-activities");
      return;
    } else if (
      newMenu !==
        ("/dashboard/survey" ||
          "/dashboard/users" ||
          "/dashboard/other-activities") &&
      (user?.type === "client" || user?.type === "admin_user")
    ) {
      navigate("/dashboard");
      Cookies.set("selectedMenuPath", newPath, { expires: 7 });
      Cookies.set("selectedMenu", newMenu, { expires: 7 });
      // Update all state values first
      setSelectedPath(newPath);
      setSelectedMenu(newMenu);
      setDevice(device);
      setDeviceCode(deviceCode);
      setIsDualCategory(dual_category);
      setCategory(category);
      setIsDemoCategory(
        demo_category ? (demo_category === "1" ? true : false) : false,
      );
      setIsCustomRecruitCategory(recruit_category ? true : false);
      setProductId(product_id);
      setMappedCategory(mapped_category);
      return;
    } else if (
      (newPath.includes("/admin-panel/survey") ||
        newPath.includes("/admin-panel/users")) &&
      user?.type === "superadmin"
    ) {
      navigate(newPath);
      // Cookies.set("selectedMenuPath", newPath, { expires: 7 });
      // Cookies.set("selectedMenu", newMenu, { expires: 7 });
      // // Update all state values first
      // setSelectedPath(newPath);
      // setSelectedMenu(newMenu);
      // setDevice(device);
      // setDeviceCode(deviceCode);
      // setIsDualCategory(dual_category);
      // setCategory(category);
      // setIsDemoCategory(
      //   demo_category ? (demo_category === "1" ? true : false) : false,
      // );
      // setProductId(product_id);
      // setMappedCategory(mapped_category);
      return;
    } else {
      Cookies.set("selectedMenuPath", newPath, { expires: 7 });
      Cookies.set("selectedMenu", newMenu, { expires: 7 });
      // Update all state values first
      setSelectedPath(newPath);
      setSelectedMenu(newMenu);
      setDevice(device);
      setDeviceCode(deviceCode);
      setIsDualCategory(dual_category);
      setCategory(category);
      setIsDemoCategory(
        demo_category ? (demo_category === "1" ? true : false) : false,
      );
      setIsCustomRecruitCategory(recruit_category ? true : false);
      setProductId(product_id);
      setMappedCategory(mapped_category);

      // Navigate after state is updated
      navigate(newPath);
      return;
    }
  };

  const handleDashboardClick = () => {
    const dashboardUrl = "/admin-panel";
    navigate(dashboardUrl);
    setSelectedPath(dashboardUrl);
    setSelectedMenu(dashboardUrl);
    setSubHeaderText("Dashboard");
    Cookies.set("subheaderText", "Dashboard", { expires: 7 });
    Cookies.set("selectedMenu", dashboardUrl, { expires: 7 });
    Cookies.set("selectedMenuPath", dashboardUrl, { expires: 7 });

    setCategoryData([]);
    // set selectedClientName here
    dispatch({
      type: SELECTED_CLIENT_NAME,
      payload: null,
    });
    setProductId(null);
    setDevice(null);
    setDeviceCode(null);
    setIsDualCategory(null);
    setCategory(null);
    setMappedCategory(null);
    setIsDemoCategory(null);
    setIsCustomRecruitCategory(null);
  };

  useEffect(() => {
    const menuItems = () => {
      // if (loading) return [];
      // debugger;
      const selectedMenuPath = Cookies.get("selectedMenuPath");
      const normSelectedMenu = normalizePath(selectedMenu || "");
      const normSelectedMenuPath = normalizePath(selectedMenuPath || "");
      const isActive = (currentPath, itemPath) => {
        currentPath = currentPath.replace(/\/$/, "");
        itemPath = itemPath.replace(/\/$/, "");
        if (itemPath === "/admin-panel") {
          return currentPath === itemPath;
        }

        if (currentPath === itemPath) {
          return true;
        }

        if (currentPath.startsWith(itemPath)) {
          const nextChar = currentPath.charAt(itemPath.length);
          return nextChar === "/" || nextChar === "" || nextChar === undefined;
        }

        return false;
      };

      // Handle client user type with surveys
      if (user?.type === "client" || user?.type === "admin_user") {
        const menuData = [
          ...categoryData.map((category) => {
            const categoryPath = `/category/${category.id}`;
            return {
              label: category?.custom_recruit
                ? "Custom Recruit"
                : `${category.category} - Dashboards`,
              command: () =>
                handleMenuItemClick(
                  categoryPath,
                  categoryPath,
                  category.device,
                  category.device_code,
                  category.category,
                  category.tag_or_coaster_category_id,
                  category.mapped_category,
                  category?.demo_category,
                  category?.custom_recruit,
                  category?.study_id,
                  category?.is_dual,
                ),
              // className: ![
              //   "/dashboard/survey/create",
              //   "/dashboard/survey/edit",
              //   "/dashboard/survey/clone",
              //   "/dashboard/users/create",
              //   "/dashboard/users/edit",
              // ].some((path) => window?.location?.pathname?.includes(path))
              //   ? Cookies.get("selectedPath") !== "/dashboard/survey" &&
              //     Cookies.get("selectedPath") !== "/dashboard/users"
              //     ? Cookies.get("selectedMenuPath")?.includes(categoryPath)
              //       ? "p-highlighter"
              //       : ""
              //     : ""
              //   : "",
              className: ![
                "/dashboard/survey/create",
                "/dashboard/survey/edit",
                "/dashboard/survey/clone",
                "/dashboard/users/create",
                "/dashboard/users/edit",
                "/dashboard/survey/view-results",
                "/dashboard/other-activities/view-results",
              ].some((path) => window?.location?.pathname?.includes(path))
                ? Cookies.get("selectedPath") !== "/dashboard/survey" &&
                  Cookies.get("selectedPath") !== "/dashboard/users"
                  ? category.tag_or_coaster_category_id === product_id &&
                    (isDemoCategory
                      ? category.demo_category === "1"
                      : category.demo_category === "0") &&
                    category?.category.toLowerCase() ===
                      selectedCategory?.toLowerCase()
                    ? "p-highlighter"
                    : ""
                  : ""
                : "",
            };
          }),
          {
            label: "Custom XMOTs",
            command: () =>
              handleMenuItemClick(
                "/dashboard/survey",
                "/dashboard/survey",
                null,
                null,
                "surveys",
                null,
                null,
                null,
                null,
                null,
                null,
              ),
            className: [
              "/dashboard/survey",
              "/dashboard/survey/create",
              "/dashboard/survey/edit",
              "/dashboard/survey/clone",
              "/dashboard/survey/view-results",
            ].some((path) => window.location.pathname.includes(path))
              ? "p-highlighter"
              : "",
          },
          {
            label: "Other Activities",
            command: () =>
              handleMenuItemClick(
                "/dashboard/other-activities",
                "/dashboard/other-activities",
                null,
                null,
                "other-activities",
                null,
                null,
                null,
                null,
                null,
                null,
              ),
            className: [
              "/dashboard/other-activities",
              "/dashboard/other-activities/view-results",
            ].some((path) => window.location.pathname.includes(path))
              ? "p-highlighter"
              : "",
          },
          ...(user?.type === "client" ||
          (user?.type === "admin_user" &&
            user?.project_access?.includes("manage_users"))
            ? [
                {
                  label: "Manage Users",
                  command: () =>
                    handleMenuItemClick(
                      "/dashboard/users",
                      "/dashboard/users",
                      null,
                      null,
                      "users",
                      null,
                      null,
                      null,
                      null,
                      null,
                      null,
                    ),
                  className: [
                    "/dashboard/users",
                    "/dashboard/users/create",
                    "/dashboard/users/edit",
                  ].some((path) => window.location.pathname.includes(path))
                    ? "p-highlighter"
                    : "",
                },
              ]
            : []),
        ];
        setMenuItemsData(menuData);
        return;
      }

      if (user?.type === "superadmin" && match) {
        const clientCustomPaths = [
          `/admin-panel/survey/${lastSegment}`,
          `/admin-panel/survey/create/${lastSegment}`,
          `/admin-panel/survey/edit/${lastSegment}`,
          `/admin-panel/survey/clone/${lastSegment}`,
          `/admin-panel/users/${lastSegment}`,
          `/admin-panel/users/create/${lastSegment}`,
          `/admin-panel/users/edit/${lastSegment}`,
        ];
        const menuData = [
          {
            label: "Dashboard",
            command: handleDashboardClick,
            className:
              normSelectedMenu === "/admin-panel" ? "p-highlighter" : "",
          },
          ...categoryData.map((category) => {
            const categoryPath = `/category/${category.id}`;
            // debugger;
            return {
              label: category?.custom_recruit
                ? "Custom Recruit"
                : `${category.category} - Dashboards`,
              command: () => {
                handleMenuItemClick(
                  `/admin-panel/categories/${lastSegment}`,
                  categoryPath,
                  category.device,
                  category.device_code,
                  category.category,
                  category.tag_or_coaster_category_id,
                  category.mapped_category,
                  category?.demo_category,
                  category?.custom_recruit,
                  category?.study_id,
                  category?.is_dual,
                );
              },
              // className:
              //   normSelectedMenu === categoryPath ? "p-highlighter" : "",
              className:
                location.pathname.includes(
                  "/admin-panel/categories/fromClient",
                ) &&
                category.tag_or_coaster_category_id === product_id &&
                (isDemoCategory
                  ? category.demo_category === "1"
                  : category.demo_category === "0") &&
                category?.category.toLowerCase() ===
                  selectedCategory?.toLowerCase()
                  ? "p-highlighter"
                  : "",
            };
          }),
          {
            label: "Custom XMOTs",
            command: () =>
              handleMenuItemClick(
                `/admin-panel/survey/${lastSegment}`,
                `/admin-panel/survey/${lastSegment}`,
                null,
                null,
                "surveys",
                null,
                null,
                null,
                null,
                null,
                null,
              ),
            className: location.pathname.includes("/admin-panel/survey")
              ? "p-highlighter"
              : "",
          },
          {
            label: "Other Activities",
            command: () =>
              handleMenuItemClick(
                `/admin-panel/other-activities/${lastSegment}`,
                `/admin-panel/other-activities/${lastSegment}`,
                null,
                null,
                "other-activities",
                null,
                null,
                null,
                null,
                null,
              ),
            className: location.pathname.includes(
              "/admin-panel/other-activities",
            )
              ? "p-highlighter"
              : "",
          },
          {
            label: "Manage Users",
            command: () =>
              handleMenuItemClick(
                `/admin-panel/users/${lastSegment}`,
                `/admin-panel/users/${lastSegment}`,
                null,
                null,
                "users",
                null,
                null,
                null,
                null,
                null,
              ),
            className: location.pathname.includes("/admin-panel/users")
              ? "p-highlighter"
              : "",
          },
        ];
        setMenuItemsData(menuData);
        return;
      }

      // Handle superadmin user type
      if (user?.type === "superadmin") {
        // debugger;
        if (
          normSelectedMenuPath === "/admin-panel/categories/fromAdmin" ||
          normSelectedMenuPath === "/admin-panel/survey" ||
          normSelectedMenuPath === "/admin-panel/users"
        ) {
          const menuData = [
            {
              label: "Dashboard",
              command: handleDashboardClick,
              className:
                normSelectedMenu === "/admin-panel" ? "p-highlighter" : "",
            },
            ...categoryData.map((category) => {
              const categoryPath = `/category/${category.id}`;
              return {
                label: `${category.category} - Dashboards`,
                command: () => {
                  handleMenuItemClick(
                    `/admin-panel/categories/fromAdmin`,
                    categoryPath,
                    category.device,
                    category.device_code,
                    category.category,
                    category.tag_or_coaster_category_id,
                    category.mapped_category,
                    category?.demo_category,
                    category?.custom_recruit,
                    category?.study_id,
                    category?.is_dual,
                  );
                },
                // className:
                //   normSelectedMenu === categoryPath ? "p-highlighter" : "",
                className:
                  category.tag_or_coaster_category_id === product_id &&
                  (isDemoCategory
                    ? category.demo_category === "1"
                    : category.demo_category === "0")
                    ? "p-highlighter"
                    : "",
              };
            }),
            // {
            //   label: "Custom XMOTs",
            //   command: () =>
            //     handleMenuItemClick(
            //       "/admin-panel/survey",
            //       "/admin-panel/survey",
            //       null,
            //       null,
            //       "surveys",
            //       null,
            //       null,
            //     ),
            //   className: window.location.pathname.includes("/admin-panel/survey")
            //     ? "p-highlighter"
            //     : "",
            // },
            // {
            //   label: "Manage Users",
            //   command: () =>
            //     handleMenuItemClick(
            //       "/admin-panel/users",
            //       "/admin-panel/users",
            //       null,
            //       null,
            //       "users",
            //       null,
            //       null,
            //     ),
            //   className: window.location.pathname.includes("/admin-panel/users")
            //     ? "p-highlighter"
            //     : "",
            // },
          ];
          setMenuItemsData(menuData);
          return;
        }
        // Return superadmin menu items
        const menuData = superAdminMenuItems.map((item) => {
          return {
            label: item.label,
            command: () => {
              setSelectedPath(item.path);
              setSelectedMenu(item.path);
              setSubHeaderText(item.label);
              Cookies.set("subheaderText", item.label, { expires: 7 });
              Cookies.set("selectedMenu", item.path, { expires: 7 });
              Cookies.set("selectedMenuPath", item.path, { expires: 7 });
              navigate(item.path);
              if (
                item.path === "/admin-panel/categories/fromAdmin" &&
                categoryData.length
              ) {
                const newSelectedMenu = `/category/${categoryData[0].id}`;
                Cookies.set("selectedMenu", newSelectedMenu, { expires: 7 });

                setSelectedMenu(newSelectedMenu);
                setProductId(categoryData[0].tag_or_coaster_category_id);
                setDevice(categoryData[0].device);
                setDeviceCode(categoryData[0]?.device_code);
                setIsDualCategory(categoryData[0]?.is_dual ? true : false);
                setCategory(categoryData[0].category);
                setMappedCategory(categoryData[0].mapped_category);
                setIsDemoCategory(
                  categoryData[0]?.demo_category
                    ? categoryData[0]?.demo_category === "1"
                      ? true
                      : false
                    : false,
                );
                setIsCustomRecruitCategory(
                  categoryData[0]?.recruit_category ? true : false,
                );
                // InitializeMenuSelection();
                // window.location.reload();
              }
            },
            className: isActive(window.location.pathname, item.path)
              ? "p-highlighter"
              : "",
          };
        });
        setMenuItemsData(menuData);
        return;
      }
      // Default case for other users
      const menuData = [
        ...categoryData.map((category) => {
          const categoryPath = `/category/${category.id}`;
          return {
            label: `${category.category} - Dashboards`,
            command: () =>
              handleMenuItemClick(
                categoryPath,
                categoryPath,
                category.device,
                category.device_code,
                category.category,
                category.tag_or_coaster_category_id,
                category.mapped_category,
                category?.demo_category,
                category?.custom_recruit,
                category?.study_id,
                category?.is_dual,
              ),
            // className: normSelectedMenu === categoryPath ? "p-highlighter" : "",
            className:
              category.tag_or_coaster_category_id === product_id &&
              (isDemoCategory
                ? category.demo_category === "1"
                : category.demo_category === "0")
                ? "p-highlighter"
                : "",
          };
        }),
        {
          label: "Custom XMOTs",
          command: () =>
            handleMenuItemClick(
              "/dashboard/survey",
              "/dashboard/survey",
              null,
              null,
              "surveys",
              null,
              null,
              null,
              null,
              null,
              null,
            ),
          className:
            normSelectedMenu === "/dashboard/survey" ? "p-highlighter" : "",
        },
        {
          label: "Other Activities",
          command: () =>
            handleMenuItemClick(
              "/dashboard/other-activities",
              "/dashboard/other-activities",
              null,
              null,
              "other-activities",
              null,
              null,
              null,
              null,
              null,
              null,
            ),
          className:
            normSelectedMenu === "/dashboard/other-activities"
              ? "p-highlighter"
              : "",
        },
        ...(user?.type === "client" ||
        (user?.type === "admin_user" &&
          user?.project_access?.includes("manage_users"))
          ? [
              {
                label: "Manage Users",
                command: () =>
                  handleMenuItemClick(
                    "/dashboard/users",
                    "/dashboard/users",
                    null,
                    null,
                    "users",
                    null,
                    null,
                    null,
                    null,
                    null,
                    null,
                  ),
                className:
                  normSelectedMenu === "/dashboard/users"
                    ? "p-highlighter"
                    : "",
              },
            ]
          : []),
      ];

      setMenuItemsData(menuData);
      return;
    };

    menuItems();
  }, [
    user,
    categoryData,
    selectedMenu,
    selectedPath,
    match,
    selectedCategory,
    product_id,
    isDemoCategory,
  ]);

  useEffect(() => {
    const handlePopState = () => {
      const currentPath = window.location.pathname;
      setSelectedPath(currentPath);
      setSelectedMenu(currentPath);
      Cookies.set("selectedPath", currentPath, { expires: 7 });
      Cookies.set("selectedMenu", currentPath, { expires: 7 });
      Cookies.set("selectedMenuPath", currentPath, { expires: 7 }); // Update selectedMenuPath cookie
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  useEffect(() => {
    if (user?.type === "client" || user?.type === "admin_user") {
      // Only update state if location.pathname differs from current to avoid flicker
      if (normalizePath(location.pathname) !== normalizePath(selectedPath)) {
        setSelectedPath(location.pathname);
        Cookies.set("selectedPath", location.pathname, { expires: 7 });
      }
      if (normalizePath(location.pathname) !== normalizePath(selectedMenu)) {
        setSelectedMenu(location.pathname);
        Cookies.set("selectedMenu", location.pathname, { expires: 7 });
      }
      setClientSubHeaderText(getClientSubheaderByPathname(location.pathname));
    }
  }, [location]);

  useEffect(() => {
    const matchVal =
      location.pathname.match(/\/fromClient-(\d+)$/) ||
      location.pathname.match(/\/fromClient-(\d+)-(\d+)$/);
    const id = matchVal ? matchVal[1] : null;

    setMatch(matchVal);
    setId(id);
  }, [location.pathname]);

  const handleShowSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  return (
    <div className="d-flex vh-100">
      <div
        className={
          showSidebar
            ? "position-fixed left-sidebar"
            : "position-fixed left-sidebar hide-sidebar"
        }
        style={{ zIndex: "999999" }}
      >
        <img src={tb_logo} className="image-fluid logo_dash" alt="Logo" />
        <Menubar
          model={menuItemsData}
          className="custom-menubar" /*key={menuKey}*/
        />
      </div>
      <div
        className={
          showSidebar
            ? "flex-grow-1 d-flex flex-column main-content"
            : "flex-grow-1 d-flex flex-column main-content hide-sidebar"
        }
      >
        {normalizePath(selectedPath) === "/admin-panel/categories/fromAdmin" ? (
          <Header
            renderReports={renderReports}
            handleShowSidebar={handleShowSidebar}
            showSidebar={showSidebar}
            selectePanelProject={selectePanelProject}
            setSelectedPanelProject={setSelectedPanelProject}
            subHeaderText={clientSubHeaderText}
          />
        ) : user?.type === "superadmin" ? (
          <AdminHeader
            renderReports={renderReports}
            handleShowSidebar={handleShowSidebar}
            showSidebar={showSidebar}
            selectePanelProject={selectePanelProject}
            setSelectedPanelProject={setSelectedPanelProject}
            subHeaderText={subHeaderText}
            clientName={match ? selectedClientName : user?.client_name}
          />
        ) : (
          <Header
            renderReports={renderReports}
            handleShowSidebar={handleShowSidebar}
            showSidebar={showSidebar}
            selectePanelProject={selectePanelProject}
            setSelectedPanelProject={setSelectedPanelProject}
            subHeaderText={clientSubHeaderText}
          />
        )}

        {renderReports ? (
          <Reports
            device={device}
            deviceCode={deviceCode}
            category={category}
            product_id={product_id}
          />
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};

export default Layout;
